import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

export type AnalyticsPeriod = '7d' | '30d' | '90d' | '12m';

interface PeriodSelectorProps {
  value: AnalyticsPeriod;
  onChange: (period: AnalyticsPeriod) => void;
}

const PERIODS: { value: AnalyticsPeriod; label: string }[] = [
  { value: '7d', label: '7 Days' },
  { value: '30d', label: '30 Days' },
  { value: '90d', label: '90 Days' },
  { value: '12m', label: '12 Months' },
];

export function periodToDates(period: AnalyticsPeriod): { dateFrom: string; dateTo: string } {
  const now = new Date();
  const to = now.toISOString().slice(0, 10);
  const days = period === '7d' ? 7 : period === '30d' ? 30 : period === '90d' ? 90 : 365;
  const from = new Date(now.getTime() - days * 86400000).toISOString().slice(0, 10);
  return { dateFrom: from, dateTo: to };
}

export function PeriodSelector({ value, onChange }: PeriodSelectorProps) {
  return (
    <Tabs value={value} onValueChange={(v) => onChange(v as AnalyticsPeriod)}>
      <TabsList className="bg-wt-bg-tertiary">
        {PERIODS.map((p) => (
          <TabsTrigger key={p.value} value={p.value} className="text-xs font-mono">
            {p.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
